export const AD_SIZE_MAPPINGS = {
  desktopSize1: [1024, 300],
  desktopSize2: [970, 250],
  tabletSize1: [768, 100],
  tabletSize2: [728, 90],
  mobileSize1: [320, 300],
  mobileSize2: [300, 250],
  mobileSize3: [320, 100]
};
